var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, EmptyState, EmptyStateBody, EmptyStateFooter, EmptyStateStatus, EmptyStateVariant, Stack, StackItem, } from '@patternfly/react-core';
import { createUseStyles } from 'react-jss';
import React from 'react';
const useStyles = createUseStyles({
    errorDescription: {
        margin: 'auto'
    }
});
const ErrorState = (_a) => {
    var { titleText = 'Something went wrong', bodyText, defaultBodyText, customFooter, ouiaId = "ErrorState", headingLevel = "h4", status = EmptyStateStatus.danger, variant = EmptyStateVariant.lg } = _a, props = __rest(_a, ["titleText", "bodyText", "defaultBodyText", "customFooter", "ouiaId", "headingLevel", "status", "variant"]);
    const classes = useStyles();
    return (React.createElement(EmptyState, Object.assign({ headingLevel: headingLevel }, (status !== 'none' && { status }), { variant: variant, titleText: titleText, "data-ouia-component-id": ouiaId }, props),
        React.createElement(EmptyStateBody, { "data-ouia-component-id": `${ouiaId}-body` },
            React.createElement(Stack, null, bodyText ? React.createElement(StackItem, { className: classes.errorDescription }, bodyText) : defaultBodyText)),
        React.createElement(EmptyStateFooter, { "data-ouia-component-id": `${ouiaId}-footer` }, customFooter ||
            (document.referrer ? (React.createElement(Button, { variant: "primary", onClick: () => history.back(), ouiaId: `${ouiaId}-back-button` }, "Return to last page")) : (React.createElement(Button, { variant: "primary", component: "a", href: ".", target: "_blank", rel: "noopener noreferrer", ouiaId: `${ouiaId}-home-button` }, "Go to home page"))))));
};
export default ErrorState;
